import { yup } from '@framework/validation/initYup.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { WidgetType } from '../../../Widget.ts';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput.tsx';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { CommonContainerWidgetConfigSchema } from '../common/CommonContainerWidgetConfigSchema.ts';
import { type IRowWidget } from './IRowWidget.ts';

export const RowWidgetConfigSchema = CommonContainerWidgetConfigSchema.shape({
  type: yup.string().exact(WidgetType.Row).required(),
})
  .required()
  .noUnknown() satisfies yup.ObjectSchema<IRowWidget>;

export interface IRowWidgetConfigComponentProps
  extends IWidgetComponentProps<IRowWidget> {}

export function RowWidgetConfigComponent(
  props: IRowWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);

  return (
    <div>
      <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />
    </div>
  );
}
